// import { Html } from "@react-three/drei";
import { useStore } from "@state/store";
import { useRef } from "react";

const Popup = ({ active }) => {
  const ref = useRef<HTMLDivElement>(null);
  const syncState = useStore((s) => s.syncState);

  if (!active) return null;
  return (
    <div
      ref={ref}
      style={{
        zIndex: 9999,
        position: "fixed",
        left: "calc(35% + 3rem",
        top: "50%",
        padding: "3rem 1.9rem",
        width: "13rem",
        height: "7rem",
        backgroundColor: "#2C1C1D",
        border: "1px solid var(--primary)",
        borderRadius: "10px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "1.7rem",
      }}
    >
      <button
        style={{
          position: "absolute",
          top: "0",
          right: "0",
          margin: ".5rem",
          backgroundColor: "transparent",
          color: "var(--accent)",
          border: "none",
          cursor: "pointer",
        }}
        onClick={() => {
          syncState({ selectedUnit: null });
        }}
      >
        X
      </button>
      <Title floor={active?.floor} id={active?.planType} />
    </div>
  );
};

export default Popup;

const Title = ({ floor, id }) => {
  const syncState = useStore((s) => s.syncState);

  return (
    <div
      style={{
        cursor: "pointer",
        flex: 1,
      }}
      onClick={() =>
        syncState({ residencePopup: true, categoriesVisible: true })}
    >
      <div
        style={{
          fontSize: "1.3rem",
          width: "100%",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "flex-start",
        }}
      >
        <span
          style={{
            fontFamily: "PrimaryFont",
            color: "var(--accent)",
          }}
        >
          Floor {floor}
        </span>
      </div>
      <div
        style={{
          color: "var(--primary)",
          fontSize: "1em",
          width: "100%",
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "flex-end",
        }}
      >
        <span
          style={{
            fontFamily: "SecondaryFont",
          }}
        >
          Plot {id}
        </span>
      </div>
      <div
        style={{
          color: "var(--accent)",
          fontSize: ".7em",
          width: "100%",
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "flex-end",
        }}
      >
        <span
          style={{
            // transform: "translateY(-1.2rem)",
            fontFamily: "SecondaryFont",
          }}
        >
          View {">"}
        </span>
      </div>
    </div>
  );
};
